const actions = {
  SET_FAV_LISTINGS: "SET_FAV_LISTINGS",
  ADD_FAV_LISTING: "ADD_FAV_LISTING",
  REMOVE_FAV_LISTING: "REMOVE_FAV_LISTING",
  setFavListings: (payload) => ({
    type: actions.SET_FAV_LISTINGS,
    payload,
  }),
  addFavListing: (payload) => ({
    type: actions.ADD_FAV_LISTING,
    payload,
  }),
  removeFavListing: (payload) => ({
    type: actions.REMOVE_FAV_LISTING,
    payload,
  }),
};

export default actions;
